import useCurrentSettingsRoute from "../hooks/useCurrentSettingsRoute";

import type { JSX, ReactNode } from "react";

//this goes inside the ContentScroll element
export default function SettingsScrollContent({
  children,
  desktopActionComponent,
}: {
  children: ReactNode;
  desktopActionComponent?: JSX.Element;
}) {
  const { label } = useCurrentSettingsRoute();

  return (
    <div className="flex flex-col max-w-[808px] mx-auto w-full gap-y-4 flex-1 ">
      <div className="flex justify-between items-start mb-6 max-lg:hidden">
        <h2 className="text-lg-bold capitalize">{label}</h2>
        {desktopActionComponent && (
          <div className="flex gap-x-2">{desktopActionComponent}</div>
        )}
      </div>
      {children}
    </div>
  );
}
